<template>
  <div class="user-wrapper">
    <div class="login-page login-page--auth-inputs">
      <div class="title">重置密码</div>
      <div class="form-list">
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">账号</div>
          </div>
          <el-input
            v-model="form.phone"
            :class="{ error: !!errorStatus }"
            @focus="clearError"
            type="text"
            class="ipt"
            placeholder="请输入手机号"
          />
        </div>

        <div class="line flex">
          <div class="form-item flex1" style="margin-bottom: 0">
            <div class="label-box">
              <div class="lable-text">验证码</div>
            </div>
            <div class="iput-box">
              <el-input
                type="text"
                class="ipt"
                v-model="form.code"
                placeholder="请输入验证码"
              />
            </div>
          </div>
          <div
            class="form-item code-btn"
            style="margin-bottom: 0"
            @click="sendCode"
            :class="{ gray: countdown > 0 }"
          >
            {{ countdown > 0 ? `获取(${countdown})` : "获取" }}
          </div>
        </div>

        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">新密码</div>
          </div>
          <div class="iput-box">
            <el-input
              v-model="form.newPassword"
              :class="{ error: !!errorStatus }"
              :type="showPassword ? 'text' : 'password'"
              class="ipt"
              placeholder="请输入新密码"
              @focus="clearError"
            />
          </div>
          <div class="push" @click="showHideEye">
            <img
              v-if="showPassword"
              class="icon"
              src="@/assets/images/eye.png"
              alt=""
            />
            <img
              v-else
              class="icon"
              src="@/assets/images/eyeclose.png"
              alt=""
            />
          </div>
        </div>

        <div class="error-box flex flex-align-center" v-if="!!errorStatus">
          <img class="error-icon" src="@/assets/images/error.png" alt="" />
          <div class="msg">{{ errorStatus }}</div>
        </div>
      </div>
      <div class="more-deal flex flex-align-center">
        <img
          @click="submitFun"
          class="sure-btn"
          src="@/assets/images/login.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import CryptoJS from "crypto-js";
import { checkUserName, getCode, forgetPassword } from "@/api/login";
import { useToast } from "vue-toast-notification";
import { useRouter } from "vue-router";

const $toast = useToast();
const router = useRouter();

// 密码显示隐藏
const showPassword = ref(false);
const showHideEye = () => {
  showPassword.value = !showPassword.value;
};

// 账号密码错误
const errorStatus = ref("");
const clearError = () => {
  errorStatus.value = "";
};

// 倒计时
const countdown = ref(0);
let timer = null;

const form = ref({
  phone: "",
  code: "",
  newPassword: "",
});

// 发送验证码
const sendCode = () => {
  if (!form.value.phone) {
    $toast.error("请输入手机号", {
      position: "top",
    });
    return;
  }
  if (countdown.value > 0) {
    return;
  }

  // 先验证账号是否存在
  checkUserName({ account: form.value.phone })
    .then((res) => {
      if (res.code == 200) {
        // 发送验证码
        getCode({
          phone: form.value.phone,
        })
          .then((codeRes) => {
            if (codeRes.code == 200) {
              $toast.success("验证码发送成功", {
                position: "top",
              });
              // 开始倒计时
              countdown.value = 60;
              timer = setInterval(() => {
                if (countdown.value > 0) {
                  countdown.value--;
                } else {
                  timer && clearInterval(timer);
                }
              }, 1000);
            } else {
              $toast.error(codeRes.message || "验证码发送失败", {
                position: "top",
              });
            }
          })
          .catch(() => {
            $toast.error("验证码发送失败", {
              position: "top",
            });
          });
      } else {
        $toast.error(res.message || "账号不存在", {
          position: "top",
        });
      }
    })
    .catch(() => {
      $toast.error("账号验证失败", {
        position: "top",
      });
    });
};

// 提交重置密码
const submitFun = async () => {
  if (!form.value.phone) {
    $toast.error("账号不能为空", {
      position: "top",
    });
    return;
  }
  if (!form.value.code) {
    $toast.error("验证码不能为空", {
      position: "top",
    });
    return;
  }
  if (!form.value.newPassword) {
    $toast.error("新密码不能为空", {
      position: "top",
    });
    return;
  }

  // 调用忘记密码接口
  forgetPassword({
    phone: form.value.phone,
    code: form.value.code,
    newPassword: CryptoJS.MD5(form.value.newPassword).toString(),
  })
    .then((res) => {
      if (res.code == 200) {
        $toast.success("密码重置成功", {
          position: "top",
        });
        // 跳转到登录页
        setTimeout(() => {
          router.push("/login/index");
        }, 1500);
      } else {
        errorStatus.value = res.message || "密码重置失败";
      }
    })
    .catch((error) => {
      errorStatus.value = error.message || "密码重置失败";
    });
};
</script>
<style lang="scss" scoped>
.user-wrapper {
  height: calc(100vh - 193px);
  padding-top: 86px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page {
  width: 406px;
  margin: 0 auto;
  // height: 100vh;
  .title {
    font-size: 48px;
    color: var(--ux-text-primary);
    line-height: 61px;
    margin-bottom: 29px;
    text-align: center;
  }
  .push {
    margin-left: 10px;
    width: 33px;
    height: 33px;
    line-height: 33px;
  }
  .icon {
    width: 100%;
  }
  .more-deal {
    margin-top: 5px;
    justify-content: center;
    position: relative;

    .sure-btn {
      width: 93px;
      height: 93px;
      &:hover {
        cursor: pointer;
      }
    }
    .more {
      position: absolute;
      right: 18px;
      top: 35px;
    }
    .for,
    .reg {
      font-size: 14px;
      font-family: Zero G Regular-Regular, Zero G Regular;
      font-weight: 400;
      color: var(--ux-text-secondary);
      line-height: 16px;
    }
    .reg {
      margin-top: 10px;
    }
  }
  .error-box {
    position: absolute;
    bottom: 20px;
    right: 0;
    transform: translateX(calc(100% + 27px));
    .error-icon {
      margin-right: 7px;
      width: 33px;
      height: 33px;
    }
    .msg {
      color: #d81e06;
    }
  }
  .push {
    margin-left: 10px;
    width: 33px;
    height: 33px;
    line-height: 33px;
  }
  .icon {
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
  .gray {
    color: #f2f2f2;
    cursor: not-allowed;
  }
}
</style>
